import HTML5Audio from './html5_audio'
export default HTML5Audio
